// Lineares Muster: N Kopien einer Auswahl entlang einer Weltachse, Kopie k
// um k×Abstand versetzt. Engine-frei. Das Kopieren läuft je Versatz über
// duplicatedParts (multiselect.js): Anker, Korpus- und Baugruppen-Ids bleiben
// innerhalb jedes kopierten Satzes konsistent, Verweise nach außen (und
// zwischen den Sätzen) werden gekappt bzw. frisch vergeben.
import { duplicatedParts } from "./multiselect"
import { partAabb } from "./snapping"

const AXIS_INDEX = { x: 0, y: 1, z: 2 }

// Versätze für k = 1…count als {x,y,z}-Deltas (mm)
export function patternOffsets(count, axis, spacing) {
  if (!(axis in AXIS_INDEX) || !Number.isFinite(count) || count < 1) return []
  return Array.from({ length: Math.floor(count) }, (_, k) => ({
    x: 0, y: 0, z: 0, [axis]: (k + 1) * spacing
  }))
}

// Vorgabe-Abstand: Ausdehnung der Auswahl auf der Achse (Welt-AABB, Rotation
// eingerechnet) + 32 mm Luft, mindestens 1
export function defaultPatternSpacing(parts, axis) {
  const index = AXIS_INDEX[axis]
  if (index === undefined || parts.length === 0) return 1
  let min = Infinity
  let max = -Infinity
  for (const part of parts) {
    const box = partAabb(part)
    min = Math.min(min, box.min[index])
    max = Math.max(max, box.max[index])
  }
  return Math.max(1, Math.round(max - min) + 32)
}

// Alle Kopien des Musters: je Versatz ein kompletter, in sich remappter Satz
export function patternCopies(parts, { count, axis, spacing }) {
  return patternOffsets(count, axis, spacing).flatMap((offset) => duplicatedParts(parts, offset))
}
